// extracted by mini-css-extract-plugin
export default {"disabled":"disabled---jeK7Q"};